import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { corporatePage } from '../../data/mock';
import { Building2, Cpu } from 'lucide-react';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Footer from '../../components/layout/Footer';

const sectionIcons = {
  company: Building2,
  technology: Cpu,
};

const sectionLinks = {
  company: '/corporativo/compania',
  technology: '/corporativo/tecnologia',
};

const Corporate = () => {
  const { language } = useLanguage();
  const content = corporatePage[language];

  return (
    <div className="min-h-screen relative">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80')`,
        }}
      >
        <div className="absolute inset-0 bg-[#1a2a3a]/85" />
      </div>

      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 pt-24 pb-16">
        <AnimateOnScroll animation="fadeInUp">
          <h1 className="text-white text-3xl sm:text-5xl md:text-6xl font-light italic mb-4 sm:mb-6 text-center">
            {content.subtitle}
          </h1>
        </AnimateOnScroll>
        <AnimateOnScroll animation="fadeInUp" delay={200}>
          <p className="text-white/80 text-lg sm:text-xl md:text-2xl font-light text-center max-w-3xl mb-16 sm:mb-20">
            {content.description}
          </p>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12 w-full max-w-3xl">
          {Object.entries(content.sections).map(([key, section], index) => {
            const Icon = sectionIcons[key];
            return (
              <AnimateOnScroll key={key} animation="scaleIn" delay={300 + index * 200}>
                <Link
                  to={sectionLinks[key]}
                  className="group flex flex-col items-center text-center"
                >
                <div className="relative w-36 h-36 sm:w-44 sm:h-44 mb-6">
                  <div className="absolute inset-0 rounded-full border-2 border-white/30 group-hover:border-[#3eb8b3] transition-all duration-500" />
                  <div className="absolute inset-4 sm:inset-5 rounded-full border border-dashed border-white/15 group-hover:border-[#3eb8b3]/40 transition-all duration-500" style={{ animation: 'spin 25s linear infinite' }} />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Icon className="text-white group-hover:text-[#3eb8b3] transition-colors duration-300" size={44} strokeWidth={1} />
                  </div>
                </div>
                <h3 className="text-white text-lg sm:text-xl tracking-wider group-hover:text-[#3eb8b3] transition-colors duration-300 mb-2">
                  {section.title}
                </h3>
                <p className="text-white/50 text-sm">
                  {section.description}
                </p>
              </Link>
              </AnimateOnScroll>
            );
          })}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Corporate;
